import React from 'react';
import { Flex, Text, Pane } from '@leverege/ui-elements';
import S from './Shared.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Unactivated(props) {
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colL",
    children: [/*#__PURE__*/_jsx("img", {
      src: "https://recovr-ui-assets.storage.googleapis.com/locator-warning.png",
      alt: "Locator warning",
      height: 80,
      width: 80
    }), /*#__PURE__*/_jsx(Text, {
      variant: "formTitle",
      children: "Locator is Not Activated"
    }), /*#__PURE__*/_jsx(Text, {
      children: "You must activate a locator to pair it to a vehicle."
    }), /*#__PURE__*/_jsx(Pane, {
      variant: "dashboardCard",
      children: /*#__PURE__*/_jsx(Pane, {
        variant: "dataCard",
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "rowM",
          children: [/*#__PURE__*/_jsx(Text, {
            className: S.ordinal,
            variant: "groupingsCount",
            children: "1"
          }), /*#__PURE__*/_jsx("div", {
            style: {
              flexGrow: 1
            },
            children: /*#__PURE__*/_jsx(Text, {
              children: "Remove the \u201CRemove to Activate\u201D sticker"
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Pane, {
      variant: "dashboardCard",
      children: /*#__PURE__*/_jsx(Pane, {
        variant: "dataCard",
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "rowM",
          children: [/*#__PURE__*/_jsx(Text, {
            className: S.ordinal,
            variant: "groupingsCount",
            children: "2"
          }), /*#__PURE__*/_jsx("div", {
            style: {
              flexGrow: 1
            },
            children: /*#__PURE__*/_jsx(Text, {
              children: "Flip the Locator over. When the LED turns green and the Locator buzzes, it\u2019s activated."
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Text, {
      variant: "link",
      children: /*#__PURE__*/_jsx("a", {
        target: "_blank",
        href: "https://intercom.help/Kudelski/en/articles/5075532-locator-activation",
        rel: "noreferrer",
        children: "Read the Documentation"
      })
    })]
  });
}
Unactivated.TYPE = 'unactivated';